import { h, createContext } from 'preact';
import { useContext, useState } from 'preact/hooks';

const Context = createContext();

export const useModal = () => useContext(Context);

export const ModalContext = ({ children }) => {
  const [modalName, setModalName] = useState(null);
  function openModal(drawerName) {
    setModalName(drawerName);
  }

  function closeModal() {
    setModalName(null);
  }

  return (
    <Context.Provider
      value={{
        modalName,
        openModal,
        closeModal,
      }}
    >
      {children}
    </Context.Provider>
  );
};
